import React, { useState } from "react"

import * as S from "./footer.styles"
import SubscribeForm from "../subscribe-form/subscribe-form.component"
import { Grid, useMediaQuery, useTheme } from "@mui/material"
import { graphql, useStaticQuery } from "gatsby"
import parse from "html-react-parser"

const Footer = ({ className, isTreezPage }) => {
  const [successMessage, setSuccessMessage] = useState(null)
  const theme = useTheme()
  const isSm = useMediaQuery(theme.breakpoints.down("md"), {
    defaultMatches: true,
  })

  const staticQuery = useStaticQuery(graphql`
    query {
      allWpPage(filter: { title: { eq: "Home" } }) {
        edges {
          node {
            id
            footer {
              address
              socialMediaLinks {
                link {
                  target
                  title
                  url
                }
              }
            }
          }
        }
      }
      footerBanner: file(relativePath: { eq: "footer-banner.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, quality: 100)
        }
      }
      mobileBanner: file(relativePath: { eq: "mobile-bg.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, quality: 100)
        }
      }
    }
  `)
  const footerInfo = staticQuery.allWpPage.edges
    ? staticQuery.allWpPage.edges[0].node.footer
    : []
  return (
    <S.Wrapper className={className}>
      <S.FooterBanner
        img={!isSm ? staticQuery.footerBanner : staticQuery.mobileBanner}
      />
      <S.CustomContainer maxWidth={"xl"}>
        {!isTreezPage ? (
          <>
            <Grid container>
              <Grid item md={6} sm={12} xs={12}>
                <S.Subtitle>Stay in touch</S.Subtitle>
                <S.Content>Sign up to receive updates and news</S.Content>
                <S.FormWrapper>
                  {!successMessage ? (
                    <SubscribeForm setSuccessMessage={setSuccessMessage} />
                  ) : (
                    <S.SuccessMessage>{successMessage}</S.SuccessMessage>
                  )}
                </S.FormWrapper>
                {!isSm && (
                  <S.TermsWrapper>
                    <S.Content>© {new Date().getFullYear()} Mosaic</S.Content>
                    <S.Link url="/privacy-terms">Privacy & Terms</S.Link>
                  </S.TermsWrapper>
                )}
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <S.Subtitle>Follow us</S.Subtitle>
                <S.SocialWrapper>
                  {footerInfo &&
                    footerInfo.socialMediaLinks?.map(link => (
                      <div>
                        <S.ExternalLink href={link.link.url} target="_blank">
                          {link.link.title}
                        </S.ExternalLink>
                      </div>
                    ))}
                </S.SocialWrapper>
              </Grid>
              <Grid item md={3} sm={6} xs={12}>
                <S.Subtitle>Contact us</S.Subtitle>
                {footerInfo.address && (
                  <S.Content>{parse(footerInfo.address)}</S.Content>
                )}
                <S.ExternalLink
                  className="mail"
                  href="mailto:hello@mosaic.green"
                >
                  hello@mosaic.green
                </S.ExternalLink>
              </Grid>
            </Grid>
            {isSm && (
              <S.TermsWrapper>
                <S.Content>© {new Date().getFullYear()} Mosaic</S.Content>
                <S.Link url="/privacy-terms">Privacy & Terms</S.Link>
              </S.TermsWrapper>
            )}
          </>
        ) : (
          <S.TermsWrapper className="treez">
            <S.Content>© {new Date().getFullYear()} Mosaic + Treez</S.Content>
          </S.TermsWrapper>
        )}
      </S.CustomContainer>
    </S.Wrapper>
  )
}

export default Footer
